<div *ngIf="selectedGroup" class="w-100 h-100 p-2">
    <!-- Role assignment -->
    <div class="h-100">
        <div class="h-100">
            <div class="lato-bold font-size-16 color-theUpsideDown mb-2">{{selectedGroup.group.GroupName}}</div>
            <div class="d-flex">
                <!-- Search -->
                <div class="search-box live-search mb-1" style="width:200px">
                    <input type="search" class="form-control" cvLocalizedPlaceholder [placeholder]="'Search'" langSection="Assign_Tool" langKey="Search" [(ngModel)]="filterValue"
                    [ngModelChangeDebounceTime]="500" (ngModelChangeDebounced)="applyFilter()" autocomplete="off" />
                    <span class="clear-input" *ngIf="filterValue.length > 0" (click)="clearFilter()"></span>
                </div>
                <!-- Select All -->
                <div class="form-check">
                  <input class="form-check-input" style="margin-left: 14px;" type="checkbox" [(ngModel)]="checkAll" (click)="selectAll()" />
                </div>
            </div>
            <!-- Table -->
            <div class="broadcastAssignment grid">
                <ag-grid-angular [gridOptions]="selectedGroup.roleAssign.tableModel" *ngIf="selectedGroup.roleAssign.tableModel != null" class="flex-grow-1 overflow-auto ag-theme-balham ag-basic" style="height: 290px;"></ag-grid-angular>
            </div>
            <!-- Footer -->
            <div class="d-flex justify-content-end flex-nowrap pt-3 border-top">
                <div class="flex-grow-1"></div>
                <button type="button" class="btn btn-text mr-2" (click)="roleAssignmentCancel()" cvLocalizedText  langSection="Common" langKey="Cancel_Button">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="roleAssignmentSave()" [disabled]="!assignButtonEnabled('role')"
                    cvLocalizedText  langSection="Common" langKey="Save_Button">Save</button>
            </div>
        </div>
    </div>
</div>

<div style="height:422px">
    <overlay-scrollbars class="h-100" [options]="scrollOptions">
        <div class="p-2" *ngIf="!(selectedGroup)">
            <!-- Send -->
            <div *ngIf="checkAnyAssigned()">
                <div class="bg-greekToMe color-theUpsideDown d-inline-block p-2 mt-2 mr-2 mb-2 rounded" style="width:294px" *ngFor="let groupAssignment of groupAssignmentsRolesFiltered">
                    <div *ngIf="checkAnyAssignedForGroup(groupAssignment.key)">
                        <div class="lato-bold d-flex">
                            <div class="flex-grow-1">{{groupAssignment.group.GroupName}}</div>
                            <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-2 clickable" (click)="editAssignment(groupAssignment)">
                                <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                            </svg>
                            <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail mr-2 clickable" (click)="deleteGroup(groupAssignment)">
                                <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                            </svg>
                        </div>
                            <div *ngFor="let type of groupAssignment.roleAssignments; index as i" style="padding-left:32px">
                                    <div class="mt-1" *ngIf="i < 6 || (i == 6 && groupAssignment.roleAssignments.length == 7) || groupAssignment.roleAssign.tableModel.showAll">
                                    <div class="mt-1">
                                        {{type.ProfileName}}
                                    </div>
                                    </div>
                            </div>
                            <div class="color-cerulean d-inline-block clickable" *ngIf="!groupAssignment.roleAssign.tableModel.showAll && groupAssignment.roleAssignments.length > 7"
                                (click)="groupAssignment.roleAssign.tableModel.showAll = true" cvLocalizedText  langSection="Broadcasts" langKey="See_More">See more</div>
                            <div class="color-cerulean clickable" *ngIf="groupAssignment.roleAssign.tableModel.showAll" (click)="groupAssignment.roleAssign.tableModel.showAll = false"
                                cvLocalizedText  langSection="Broadcasts" langKey="See_Less">See less</div>
                    </div>
            </div>
        </div></div>
    </overlay-scrollbars>
</div>
